/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScreeningFlowTestResult
 */
export interface InternalApiScreeningFlowTestResult {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningFlowTestResult
     */
    screeningTestId: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlowTestResult
     */
    status: string;
}

/**
 * Check if a given object implements the InternalApiScreeningFlowTestResult interface.
 */
export function instanceOfInternalApiScreeningFlowTestResult(value: object): value is InternalApiScreeningFlowTestResult {
    if (!('screeningTestId' in value) || value['screeningTestId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function InternalApiScreeningFlowTestResultFromJSON(json: any): InternalApiScreeningFlowTestResult {
    return InternalApiScreeningFlowTestResultFromJSONTyped(json, false);
}

export function InternalApiScreeningFlowTestResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningFlowTestResult {
    if (json == null) {
        return json;
    }
    return {
        
        'screeningTestId': json['screeningTestId'],
        'status': json['status'],
    };
}

export function InternalApiScreeningFlowTestResultToJSON(json: any): InternalApiScreeningFlowTestResult {
    return InternalApiScreeningFlowTestResultToJSONTyped(json, false);
}

export function InternalApiScreeningFlowTestResultToJSONTyped(value?: InternalApiScreeningFlowTestResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'screeningTestId': value['screeningTestId'],
        'status': value['status'],
    };
}

